module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register-box column"
  }, [_vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "form-box column",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "form-item row m-column"
  }, [_c('el-form-item', {
    attrs: {
      "label": "お名前",
      "prop": "realname"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "お名前を入力"
    },
    model: {
      value: (_vm.ruleForm.realname),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "realname", $$v)
      },
      expression: "ruleForm.realname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "フリガナ (カタカナを入力)",
      "prop": "falsename"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "フリガナを入力"
    },
    model: {
      value: (_vm.ruleForm.falsename),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "falsename", $$v)
      },
      expression: "ruleForm.falsename"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item row m-column"
  }, [_c('el-form-item', {
    attrs: {
      "label": "ニックネーム (全角8文字まで)",
      "prop": "nickname"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "8",
      "placeholder": "ニックネームを入力"
    },
    model: {
      value: (_vm.ruleForm.nickname),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "nickname", $$v)
      },
      expression: "ruleForm.nickname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "sex-box m-row",
    attrs: {
      "label": "性別",
      "prop": "sex"
    }
  }, [_c('el-radio-group', {
    staticClass: "m-row",
    model: {
      value: (_vm.ruleForm.sex),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "sex", $$v)
      },
      expression: "ruleForm.sex"
    }
  }, _vm._l((_vm.sexBox), function(item, index) {
    return _c('el-radio-button', {
      key: index,
      attrs: {
        "label": index,
        "value": index,
        "name": "sex"
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item row m-column"
  }, [_c('el-form-item', [_c('div', {
    staticClass: "row m-row"
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "label": "生年月",
      "prop": "year"
    }
  }, [_c('el-select', {
    staticClass: "birthday-year",
    attrs: {
      "placeholder": "年を選択してください"
    },
    on: {
      "change": _vm.monthChange
    },
    model: {
      value: (_vm.ruleForm.year),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "year", $$v)
      },
      expression: "ruleForm.year"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "年",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((2022), function(index) {
    return (index >= 1900) ? _c('el-option', {
      key: index,
      attrs: {
        "label": index,
        "value": index
      }
    }) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " ",
      "prop": "month"
    }
  }, [_c('el-select', {
    staticClass: "birthday-month",
    attrs: {
      "placeholder": "月を選択してください"
    },
    on: {
      "change": _vm.monthChange
    },
    model: {
      value: (_vm.ruleForm.month),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "month", $$v)
      },
      expression: "ruleForm.month"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "月",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((12), function(index) {
    return (index >= 1) ? _c('el-option', {
      key: index,
      attrs: {
        "label": index,
        "value": index
      }
    }) : _vm._e()
  })], 2)], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "住所",
      "prop": "address"
    }
  }, [_c('el-select', {
    staticClass: "select-region",
    attrs: {
      "placeholder": "都道府県を選択"
    },
    model: {
      value: (_vm.ruleForm.address),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "address", $$v)
      },
      expression: "ruleForm.address"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "選択してください",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.region), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item,
        "value": item
      }
    })
  })], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item row m-column"
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-right": "0"
    },
    attrs: {
      "label": "職業",
      "prop": "job"
    }
  }, [_c('el-select', {
    staticClass: "select-job",
    attrs: {
      "placeholder": "職業を選択"
    },
    model: {
      value: (_vm.ruleForm.job),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "job", $$v)
      },
      expression: "ruleForm.job"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "選択してください",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.job), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item,
        "value": item
      }
    })
  })], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item row m-column"
  }, [_c('el-form-item', {
    attrs: {
      "label": "メールアドレス (有効なメールアドレスを入力)",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "メールアドレスを入力",
      "disabled": _vm.isVerify
    },
    model: {
      value: (_vm.ruleForm.email),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "email", $$v)
      },
      expression: "ruleForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "メールアドレスを再入力",
      "prop": "reemail"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "確認のためメールアドレスを再入力",
      "disabled": _vm.isVerify
    },
    model: {
      value: (_vm.ruleForm.reemail),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "reemail", $$v)
      },
      expression: "ruleForm.reemail"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item row m-column"
  }, [_c('el-form-item', {
    attrs: {
      "label": "パスワード (6文字以上入力)",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "show-password": "",
      "placeholder": "6文字以上のパスワードを入力"
    },
    model: {
      value: (_vm.ruleForm.password),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "password", $$v)
      },
      expression: "ruleForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "パスワードを再入力",
      "prop": "repassword"
    }
  }, [_c('el-input', {
    attrs: {
      "show-password": "",
      "placeholder": "確認のためパスワードを再入力"
    },
    model: {
      value: (_vm.ruleForm.repassword),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "repassword", $$v)
      },
      expression: "ruleForm.repassword"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "agree-box"
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "agree"
    }
  }, [_c('el-checkbox', {
    staticClass: "agree-check",
    attrs: {
      "label": "",
      "name": "agree"
    },
    model: {
      value: (_vm.ruleForm.agree),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "agree", $$v)
      },
      expression: "ruleForm.agree"
    }
  }), _vm._v(" "), _c('el-link', {
    attrs: {
      "href": "https://online.engagement-card.com/#/terms-of-service",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "type": "primary"
    }
  }, [_vm._v("利用規約")]), _vm._v("に同意する\n        ")], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btns-box row row-center m-column",
    staticStyle: {
      "width": "80%",
      "margin": "0 auto",
      "text-align": "center"
    }
  }, [_c('el-button', {
    staticClass: "register-btn",
    on: {
      "click": function($event) {
        return _vm.doReg('ruleForm')
      }
    }
  }, [_vm._v("アカウントを作成する")])], 1), _vm._v(" "), _c('div', {
    staticClass: "btns-box row row-center m-column",
    staticStyle: {
      "width": "80%",
      "margin": "10px auto",
      "text-align": "center"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("アカウントをお持ちの方はこちらへ")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register-header column"
  }, [_c('div', {
    staticClass: "title-box row"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/logo.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("アカウント作成")])]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("もっとワクワークする世の中を")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bfa2a65"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/Register.vue
// module id = 893
// module chunks = 1